export default __webpack_public_path__ + "static/media/electricity.55010bff.png";